export default __webpack_public_path__ + "static/media/network.93907b0b.png";